import React, { useState, useCallback } from 'react'
import styles from './index.module.less'
import Modal from '../common/modal-login'
import appInstall from '@/utils/appUtils/appInstall'
import { isWeChat } from '@/utils/appUtils/getDevice'

const Login: React.FC<{
  inviteCode: string
  login: string
  callback: (val: boolean) => void
  open1: string
  open2: string
  download: string
}> = ({ inviteCode, login, callback, open1, open2, download }) => {
  const [visible, setVisible] = useState(false)
  const [isLogined, setIsLogined] = useState(null)
  const [isShow, setIsShwo] = useState(true)

  const handleLogin = useCallback(
    (val: boolean, isShow?: boolean, isLogined?: boolean) => {
      setVisible(val)
      setIsLogined(isLogined)
      setIsShwo(!isShow)
      isShow && callback(isShow)
    },
    [callback]
  )

  const handleAppInstall = () => {
    let original = location.href || ''

    /* 清空站外标识 */
    if (original.includes('run=outside')) {
      original = original.replace('run=outside&', '')
    }
    let symbolic = '?'
    if (original.includes('?')) {
      symbolic = '&'
    }
    const url = isLogined ? encodeURIComponent([original, symbolic, 'derive=arouse'].join('')) : ''
    appInstall('/web/browser', {
      url,
    })
  }

  if (isWeChat()) {
    return (
      <div className={styles.login}>
        <div className={styles.text} onClick={() => handleAppInstall()}>
          {download}
        </div>
      </div>
    )
  }

  return (
    <>
      <div className={styles.login}>
        {isShow && (
          <div className={styles.text} onClick={() => handleLogin(true)}>
            {login}
          </div>
        )}
        {!isShow && (
          <div className={styles.text} onClick={() => handleAppInstall()}>
            {isLogined ? open1 : open2}
          </div>
        )}
      </div>
      {visible && (
        <Modal
          inviteCode={inviteCode}
          visible={visible}
          callback={(val?: boolean, isNewUser?: boolean) => handleLogin(false, val, isNewUser)}
        />
      )}
    </>
  )
}

export default Login
